module.exports = __webpack_public_path__ + "static/viernes-28-11-d590316751fd013be6ad6bb2989f970e.jpg";